import { buildDataset } from "./generate";

let _cache = null;
export function getDataset() {
  if (!_cache) _cache = buildDataset();
  return _cache;
}

export function getFixtureById(id) {
  const ds = getDataset();
  for (const lg of ds.leagues) {
    for (const md of lg.matchdays) {
      const f = md.fixtures.find((x) => x.id === id);
      if (f) return f;
    }
  }
  return null;
}

export function getLiveFixtures(leagueId) {
  const ds = getDataset();
  const lg = ds.leagues.find((l) => l.id === leagueId);
  const md = lg.matchdays.find((m) => m.isLive);
  return md.fixtures;
}
